export function ScheduleSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/schedule.svg'"></ng-include>`
    }
}
            